/**
 * Utility classes.
 * For use in Lit components, separate exports are provided that wrap the code in `unsafeCSS` so that they can be used directly in the `styles` array.
 */
import { unsafeCSS } from 'lit';
/**
 * Hides an element visually, but not from AT
 */
export const visuallyHidden = `
    .visually-hidden:not(:focus):not(:active) {
        clip: rect(0 0 0 0);
        clip-path: inset(50%);
        height: 1px;
        overflow: hidden;
        position: absolute;
        white-space: nowrap;
        width: 1px;
    }
`;
export const litVisuallyHidden = unsafeCSS(visuallyHidden);
